/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TokenBody
 */
export interface TokenBody {
    /**
     * 
     * @type {string}
     * @memberof TokenBody
     */
    token: string;
}

export function TokenBodyFromJSON(json: any): TokenBody {
    return TokenBodyFromJSONTyped(json, false);
}

export function TokenBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function TokenBodyToJSON(value?: TokenBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}


